module.exports = __webpack_public_path__ + "static/media/bitmap-a-a-1@1x.185372e3.png";